// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_contentContainer__RIf6M {
  height: 54vh;
  overflow-y: scroll; }

.styles_feedContainer__LMGHh {
  width: 100%;
  height: 100%; }

.styles_searchContainer__lsljP {
  margin: 1rem 2rem; }

.styles_searchInput__hK7DS {
  width: 100%; }

.styles_trackedTimeItem__4Hr7h {
  margin-bottom: 0.5rem; }

.styles_header__0IfqS {
  display: flex;
  justify-content: space-between;
  align-items: center; }

.styles_feedItem__gKSsU {
  min-height: 18rem;
  margin: 1rem 2rem; }
  .styles_feedItem__gKSsU h2 {
    font-size: 1.2rem; }

.styles_selectableFeedItem__L5I2j {
  cursor: pointer;
  transition: border-color 0.2s ease; }
  .styles_selectableFeedItem__L5I2j:hover {
    border-color: #72abab80; }

.styles_selectedFeedItem__V4hQn {
  border-color: #72abab;
  border-width: 2px;
  box-shadow: 0 4px 12px #72abab5c, 0 2px 6px #73abab1a; }

.styles_selectButton__m1h3M {
  position: absolute;
  width: 100%;
  bottom: 0;
  background: white;
  padding: 1rem 0rem;
  border-top: 1px solid #8080802e;
  z-index: 10;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1); }
  .styles_selectButton__m1h3M button {
    margin: 0rem 2rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/timetracker/submodules/trackedTime/components/TrackTimeForm/SelectTrackedTimeFeed/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACI,YAAY;EACZ,kBAAkB,EAAA;;AAGtB;EACI,WAAW;EACX,YAAY,EAAA;;AAGhB;EACI,iBAAiB,EAAA;;AAIrB;EACI,WAAW,EAAA;;AAGf;EACI,qBAAqB,EAAA;;AAGzB;EACI,aAAa;EACb,8BAA8B;EAC9B,mBAAmB,EAAA;;AAGvB;EACI,iBAAiB;EACjB,iBAAiB,EAAA;EAFrB;IAIQ,iBAAiB,EAAA;;AAIzB;EACI,eAAe;EACf,kCAAkC,EAAA;EAFtC;IAKQ,uBCFgB,EAAA;;ADMxB;EACI,qBCVgB;EDWhB,iBAAiB;EACjB,qDCPoB,EAAA;;ADUxB;EACI,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,+BC/Cc;EDgDd,WAAW;EACX,yCAAyC,EAAA;EAR7C;IAUQ,iBAAiB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.contentContainer {\n    height: 54vh;\n    overflow-y: scroll;\n}\n\n.feedContainer {\n    width: 100%;\n    height: 100%;\n}\n\n.searchContainer {\n    margin: 1rem 2rem;\n    // width: 100%;\n}\n\n.searchInput {\n    width: 100%;\n}\n\n.trackedTimeItem {\n    margin-bottom: 0.5rem;\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.feedItem {\n    min-height: 18rem;\n    margin: 1rem 2rem;\n    h2 {\n        font-size: 1.2rem;\n    }\n}\n\n.selectableFeedItem {\n    cursor: pointer;\n    transition: border-color 0.2s ease;\n    \n    &:hover {\n        border-color: $ocean_blue50;\n    }\n}\n\n.selectedFeedItem {\n    border-color: $ocean_blue;\n    border-width: 2px;\n    box-shadow: 0 4px 12px $ocean_blue36, 0 2px 6px $ocean_blue10;\n}\n\n.selectButton {\n    position: absolute;\n    width: 100%;\n    bottom: 0;\n    background: white;\n    padding: 1rem 0rem;\n    border-top: 1px solid $grey18;\n    z-index: 10;\n    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);\n    button {\n        margin: 0rem 2rem;\n    }\n}","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentContainer": `styles_contentContainer__RIf6M`,
	"feedContainer": `styles_feedContainer__LMGHh`,
	"searchContainer": `styles_searchContainer__lsljP`,
	"searchInput": `styles_searchInput__hK7DS`,
	"trackedTimeItem": `styles_trackedTimeItem__4Hr7h`,
	"header": `styles_header__0IfqS`,
	"feedItem": `styles_feedItem__gKSsU`,
	"selectableFeedItem": `styles_selectableFeedItem__L5I2j`,
	"selectedFeedItem": `styles_selectedFeedItem__V4hQn`,
	"selectButton": `styles_selectButton__m1h3M`
};
export default ___CSS_LOADER_EXPORT___;
